import sdl from '@jds/react-generated-sdl/JDSInputCode';
import type { JDSInputCodeProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputCodeProps } from '../logic';

const Component = (props: InputCodeProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    state = 'undefined',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { disabled, state, ...rest },
    'JDSInputCode',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputCode = withLogic(Component) as React.FC<InputCodeProps> & {
  slotName?: string;
};

InputCode.displayName = 'InputCode';
InputCode.slotName = 'jds_input_code';

export { InputCode, type JDSInputCodeProps };
